import React, { useCallback } from 'react';
import { ConfirmModal } from '../../../../components/ConfirmModal';
import { useLibraryPageController } from '../../../library';
import { useSeedanceLibraryStore } from '../../../../store/seedanceLibraryStore';
import { getLocalStorageValue, SEEDANCE_STORAGE_KEYS } from '../../../../utils/seedanceStorage';

export const LibraryModals: React.FC = () => {
  const hasTaskListConfig = useCallback(() => {
    const userId = getLocalStorageValue(SEEDANCE_STORAGE_KEYS.configUserId).trim();
    return Boolean(userId);
  }, []);

  const createGroupVisible = useSeedanceLibraryStore((s) => s.createGroupVisible);
  const setCreateGroupVisible = useSeedanceLibraryStore((s) => s.setCreateGroupVisible);
  const newGroupName = useSeedanceLibraryStore((s) => s.newGroupName);
  const setNewGroupName = useSeedanceLibraryStore((s) => s.setNewGroupName);
  const newGroupDescription = useSeedanceLibraryStore((s) => s.newGroupDescription);
  const setNewGroupDescription = useSeedanceLibraryStore((s) => s.setNewGroupDescription);
  const libraryAssetAwaitingDelete = useSeedanceLibraryStore((s) => s.libraryAssetAwaitingDelete);
  const libDeletingAssetId = useSeedanceLibraryStore((s) => s.libDeletingAssetId);
  const libraryGroupAwaitingDelete = useSeedanceLibraryStore((s) => s.libraryGroupAwaitingDelete);
  const libraryGroupDeleting = useSeedanceLibraryStore((s) => s.libraryGroupDeleting);

  const {
    createLibraryGroup,
    dismissLibraryAssetDeleteModal,
    commitLibraryAssetDelete,
    dismissLibraryGroupDeleteModal,
    commitLibraryGroupDelete,
  } = useLibraryPageController({ active: false, hasTaskListConfig, portraitListManaged: false });

  return (
    <>
      {/* Create library group modal */}
      <div className={`config-mask${createGroupVisible ? '' : ' hidden'}`}>
        <div className="config-box">
          <button
            className="config-close"
            onClick={() => setCreateGroupVisible(false)}
            aria-label="关闭新增素材组弹窗"
          >
            ×
          </button>
          <h3>➕ 新增素材组</h3>
          <div className="config-field">
            <label>素材库名称</label>
            <input
              className="config-input"
              type="text"
              value={newGroupName}
              onChange={(e) => setNewGroupName(e.target.value)}
              placeholder="请输入素材库名称"
            />
          </div>
          <div className="config-field">
            <label>描述</label>
            <input
              className="config-input"
              type="text"
              value={newGroupDescription}
              onChange={(e) => setNewGroupDescription(e.target.value)}
              placeholder="请输入描述，可留空"
            />
          </div>
          <div className="config-actions">
            <button className="btn" onClick={() => setCreateGroupVisible(false)}>
              取消
            </button>
            <button className="btn primary" onClick={createLibraryGroup}>
              新增
            </button>
          </div>
        </div>
      </div>

      <ConfirmModal
        open={!!libraryAssetAwaitingDelete}
        title="删除素材"
        cancelLabel="取消"
        confirmLabel="删除"
        confirmBusyLabel="删除中…"
        confirmVariant="danger"
        busy={
          !!libraryAssetAwaitingDelete &&
          libDeletingAssetId === libraryAssetAwaitingDelete.id
        }
        onCancel={dismissLibraryAssetDeleteModal}
        onConfirm={commitLibraryAssetDelete}
      >
        <p>
          确定删除素材「
          <strong>{libraryAssetAwaitingDelete?.name ?? '—'}</strong>
          」吗？删除后不可恢复。
        </p>
      </ConfirmModal>

      <ConfirmModal
        open={!!libraryGroupAwaitingDelete}
        title="删除素材组"
        cancelLabel="取消"
        confirmLabel="删除"
        confirmBusyLabel="删除中…"
        confirmVariant="danger"
        busy={libraryGroupDeleting}
        onCancel={dismissLibraryGroupDeleteModal}
        onConfirm={commitLibraryGroupDelete}
      >
        <p>
          确定删除素材组「
          <strong>{libraryGroupAwaitingDelete?.name ?? '—'}</strong>
          」吗？删除后不可恢复。
        </p>
      </ConfirmModal>
    </>
  );
};
